/**
 * Site redesign token registry — RedisiginProductPage Media / semantic vars.
 * Figma: https://www.figma.com/design/87jtAiFxEkp2UW470m1uow/RedisiginProductPage?node-id=1-1462
 */

export const FAIR_RD_ICON_CONTAINER_SIZES = [12, 16, 20] as const
export type FairRdIconContainerSize = (typeof FAIR_RD_ICON_CONTAINER_SIZES)[number]

export interface FairRdSemanticToken {
  figma: string
  cssVar: string
  value: string
}

/** Semantic tokens used by PDP redesign (see redesign.css) */
export const FAIR_RD_SEMANTIC_TOKENS: FairRdSemanticToken[] = [
  { figma: 'color/text/primary', cssVar: '--color-text-primary', value: '#1a2133' },
  { figma: 'color/text/secondary', cssVar: '--color-text-secondary', value: '#5a6172' },
  { figma: 'color/text/muted', cssVar: '--color-text-muted', value: '#8a90a0' },
  { figma: 'color/text/muted-on-dark', cssVar: '--color-text-muted-on-dark', value: 'rgba(255,255,255,0.6)' },
  { figma: 'color/primary', cssVar: '--color-primary', value: '#1a2133' },
  { figma: 'color/line/hairline', cssVar: '--color-line-hairline', value: 'rgba(26,33,51,0.1)' },
  { figma: 'color/fill/chip', cssVar: '--color-fill-chip', value: 'rgba(26,33,51,0.06)' },
  { figma: 'color/bg/surface', cssVar: '--color-bg-surface', value: '#ffffff' },
  { figma: 'color/bg/page', cssVar: '--color-bg-page', value: '#f5f4f8' },
  { figma: 'color/bg/look', cssVar: '--color-bg-look', value: '#e9e7ef' },
  { figma: 'color/signal/positive/bg', cssVar: '--color-signal-positive-bg', value: 'rgba(46,106,87,0.08)' },
  { figma: 'color/signal/positive/text', cssVar: '--color-signal-positive-text', value: '#2e6a57' },
  { figma: 'radius/control', cssVar: '--radius-control', value: '4px' },
  { figma: 'radius/card', cssVar: '--radius-card', value: '8px' },
  { figma: 'radius/full', cssVar: '--radius-full', value: '999px' },
]

/** Icons added from redesign Media board (1:1462) — new slugs */
export const FAIR_RD_NEW_ICON_SLUGS = [
  'arrow-back',
  'arrow-forward',
  'arrow-upward',
  'arrow-upward-big',
  'chart',
  'chevron-down',
  'discount',
  'fast-returns',
  'fastest-delivery',
  'fitting-available',
  'link',
  'mic',
  'pay',
  'send',
] as const

export type FairRdNewIconSlug = (typeof FAIR_RD_NEW_ICON_SLUGS)[number]

export const FAIR_RD_DESKTOP_MIN_WIDTH = 1024
